import React from "react";
import { useResource } from "../hooks";
import { api, fmtINR, fmtNum } from "../api";
import AskOIM from "../components/AskOIM";

export default function ResourceIntelligence() {
  const data = useResource(() => api.resources(), [], 3000);
  const items = data?.resources || [];

  return (
    <div className="stack" data-testid="resource-intelligence">
      <div className="page-title">
        <div>
          <h1>Resource Intelligence</h1>
          <div className="sub">Live tracking of all process inputs · variance to benchmark</div>
        </div>
      </div>

      <div className="grid-3">
        {items.map(r => (
          <div key={r.key} className="card" data-testid={`resource-${r.key}`}>
            <div className="card-header">
              <div className="card-title">{r.name}</div>
              <span className="chip">{r.intensity_unit}</span>
            </div>
            <div className="card-body">
              <div className="mono muted" style={{ fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase" }}>Current Intensity</div>
              <div className="mono" style={{ fontSize: 28, fontWeight: 700, color: r.variance_inrh > 100 ? "var(--brand-amber-soft)" : "var(--text-primary)", marginTop: 4 }}>
                {fmtNum(r.intensity, 2)}<span style={{ fontSize: 11, marginLeft: 5, color: "var(--text-tertiary)", fontWeight: 400 }}>{r.intensity_unit}</span>
              </div>
              <div className="mono" style={{ fontSize: 11, color: "var(--text-tertiary)", marginTop: 4 }}>Benchmark {fmtNum(r.intensity_bench, 2)}</div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 16, paddingTop: 12, borderTop: "1px solid var(--border-soft)" }}>
                <div>
                  <div className="mono muted" style={{ fontSize: 9.5, letterSpacing: "0.14em", textTransform: "uppercase" }}>Cost Impact</div>
                  <div className="mono" style={{ fontSize: 16, fontWeight: 700, color: "var(--brand-amber-soft)", marginTop: 4 }}>{fmtINR(r.variance_inrh)}<span style={{ fontSize: 10, color: "var(--text-tertiary)", marginLeft: 3 }}>/hr</span></div>
                </div>
                <div>
                  <div className="mono muted" style={{ fontSize: 9.5, letterSpacing: "0.14em", textTransform: "uppercase" }}>Improvement</div>
                  <div className="mono" style={{ fontSize: 16, fontWeight: 700, color: "var(--brand-green-soft)", marginTop: 4 }}>+{fmtNum(r.improvement_pct, 1)}%</div>
                </div>
              </div>

              <AskOIM question={r.ai_question} source={r.key} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
